import i18n from "i18next";
import { getInitialLanguage } from "./getInitialLanguage";
import { initReactI18next } from "react-i18next";
/* GUARD */
import enRouteGuard from "./locales/en/guard.json";
import caRouteGuard from "./locales/ca/guard.json";
import esRouteGuard from "./locales/es/guard.json";
import nlRouteGuard from "./locales/nl/guard.json";
/* HOME PAGE */
import enHomePage from "./locales/en/home.json";
import caHomePage from "./locales/ca/home.json";
import esHomePage from "./locales/es/home.json";
import nlHomePage from "./locales/nl/home.json";
/* REGISTRATION */
import enRegistration from "./locales/en/homebuyer-registration.json";
import caRegistration from "./locales/ca/homebuyer-registration.json";
import esRegistration from "./locales/es/homebuyer-registration.json";
import nlRegistration from "./locales/nl/homebuyer-registration.json";
/* COMMON */
import enCommon from "./locales/en/common.json";
import caCommon from "./locales/ca/common.json";
import esCommon from "./locales/es/common.json";
import nlCommon from "./locales/nl/common.json";
/* NOTIFICATIONS */
import enNotifications from "./locales/en/notifications.json";
import caNotifications from "./locales/ca/notifications.json";
import esNotifications from "./locales/es/notifications.json";
import nlNotifications from "./locales/nl/notifications.json";
/* HOMEBUYER SIDEBAR */
import enHomebuyerSidebar from "./locales/en/homebuyer-sidebar.json";
import caHomebuyerSidebar from "./locales/ca/homebuyer-sidebar.json";
import esHomebuyerSidebar from "./locales/es/homebuyer-sidebar.json";
import nlHomebuyerSidebar from "./locales/nl/homebuyer-sidebar.json";
/* HOMEBUYER FIRST LOGIN */
import enHomebuyerFirstLogin from "./locales/en/homebuyer-first-login.json";
import caHomebuyerFirstLogin from "./locales/ca/homebuyer-first-login.json";
import esHomebuyerFirstLogin from "./locales/es/homebuyer-first-login.json";
import nlHomebuyerFirstLogin from "./locales/nl/homebuyer-first-login.json";
/*HOMEBUYER DASHBOARD*/
import enHomebuyerDashboard from "./locales/en/homebuyer-dashboard.json";
import caHomebuyerDashboard from "./locales/ca/homebuyer-dashboard.json";
import esHomebuyerDashboard from "./locales/es/homebuyer-dashboard.json";
import nlHomebuyerDashboard from "./locales/nl/homebuyer-dashboard.json";
/*HOMEBUYER EXTERNAL OSS*/
import enHomebuyerExternalOss from "./locales/en/external-renovation.json";
import caHomebuyerExternalOss from "./locales/ca/external-renovation.json";
import esHomebuyerExternalOss from "./locales/es/external-renovation.json";
import nlHomebuyerExternalOss from "./locales/nl/external-renovation.json";
/*HOMEBUYER APPLICATION INTRO*/
import enDossierIntro from "./locales/en/dossierIntro.json";
import caDossierIntro from "./locales/ca/dossierIntro.json";
import esDossierIntro from "./locales/es/dossierIntro.json";
import nlDossierIntro from "./locales/nl/dossierIntro.json";
/*SELECT SERVICE*/
import enSelectService from "./locales/en/select-service.json";
import caSelectService from "./locales/ca/select-service.json";
import esSelectService from "./locales/es/select-service.json";
import nlSelectService from "./locales/nl/select-service.json";
/*HOMEBUYER APPLICATION STEPS*/
import enDossierLayout from "./locales/en/homebuyer-dossier-layout.json";
import caDossierLayout from "./locales/ca/homebuyer-dossier-layout.json";
import esDossierLayout from "./locales/es/homebuyer-dossier-layout.json";
import nlDossierLayout from "./locales/nl/homebuyer-dossier-layout.json";
/*HOMEBUYER PERSONAL INFO*/
import enHomebuyerPersonalInfo from "./locales/en/homebuyer-personal-info.json";
import caHomebuyerPersonalInfo from "./locales/ca/homebuyer-personal-info.json";
import esHomebuyerPersonalInfo from "./locales/es/homebuyer-personal-info.json";
import nlHomebuyerPersonalInfo from "./locales/nl/homebuyer-personal-info.json";
/*HOMEBUYER FINANCIAL INFO*/
import enHomebuyerFinancialInfo from "./locales/en/homebuyer-financial-info.json";
import caHomebuyerFinancialInfo from "./locales/ca/homebuyer-financial-info.json";
import esHomebuyerFinancialInfo from "./locales/es/homebuyer-financial-info.json";
import nlHomebuyerFinancialInfo from "./locales/nl/homebuyer-financial-info.json";
/*HOMEBUYER DOCUMENTS*/
import enHomebuyerDocuments from "./locales/en/homebuyer-documents.json";
import caHomebuyerDocuments from "./locales/ca/homebuyer-documents.json";
import esHomebuyerDocuments from "./locales/es/homebuyer-documents.json";
import nlHomebuyerDocuments from "./locales/nl/homebuyer-documents.json";
/*HOMEBUYER EXTRACTED DATA*/
import enHomebuyerExtractedData from "./locales/en/homebuyer-extracted-data.json";
import caHomebuyerExtractedData from "./locales/ca/homebuyer-extracted-data.json";
import esHomebuyerExtractedData from "./locales/es/homebuyer-extracted-data.json";
import nlHomebuyerExtractedData from "./locales/nl/homebuyer-extracted-data.json";
/*HOMEBUYER PROPERTY INFO*/
import enHomebuyerPropertylInfo from "./locales/en/homebuyer-property-info.json";
import caHomebuyerPropertylInfo from "./locales/ca/homebuyer-property-info.json";
import esHomebuyerPropertylInfo from "./locales/es/homebuyer-property-info.json";
import nlHomebuyerPropertylInfo from "./locales/nl/homebuyer-property-info.json";
/*HOMEBUYER DASHBOARD DRAFT*/
import enHomebuyerReviewSubmit from "./locales/en/homebuyer-review-submit.json";
import caHomebuyerReviewSubmit from "./locales/ca/homebuyer-review-submit.json";
import esHomebuyerReviewSubmit from "./locales/es/homebuyer-review-submit.json";
import nlHomebuyerReviewSubmit from "./locales/nl/homebuyer-review-submit.json";
// /*HOMEBUYER DASHBOARD DRAFT*/
import enHomebuyerDashboardDraft from "./locales/en/homebuyer-dashboard-draft.json";
import caHomebuyerDashboardDraft from "./locales/ca/homebuyer-dashboard-draft.json";
import esHomebuyerDashboardDraft from "./locales/es/homebuyer-dashboard-draft.json";
import nlHomebuyerDashboardDraft from "./locales/nl/homebuyer-dashboard-draft.json";
// /*HOMEBUYER OSS MOODAL*/
import enHomebuyerOssModal from "./locales/en/homebuyer-oss-modal.json";
import caHomebuyerOssModal from "./locales/ca/homebuyer-oss-modal.json";
import esHomebuyerOssModal from "./locales/es/homebuyer-oss-modal.json";
import nlHomebuyerOssModal from "./locales/nl/homebuyer-oss-modal.json";
// /*HOMEBUYER OSS I HAVE A PROPERTY*/
import enHomebuyerOssPropertyDetails from "./locales/en/homebuyer-oss-property-details.json";
import caHomebuyerOssPropertyDetails from "./locales/ca/homebuyer-oss-property-details.json";
import esHomebuyerOssPropertyDetails from "./locales/es/homebuyer-oss-property-details.json";
import nlHomebuyerOssPropertyDetails from "./locales/nl/homebuyer-oss-property-details.json";
// /*HOMEBUYER OSS PARTNERS*/
import enHomebuyerOssPartners from "./locales/en/homebuyer-oss-partners.json";
import caHomebuyerOssPartners from "./locales/ca/homebuyer-oss-partners.json";
import esHomebuyerOssPartners from "./locales/es/homebuyer-oss-partners.json";
import nlHomebuyerOssPartners from "./locales/nl/homebuyer-oss-partners.json";
// /*HOMEBUYER OSS REVIEW SUBMIT*/
import enHomebuyerOssReviewSubmit from "./locales/en/homebuyer-oss-review-submit.json";
import caHomebuyerOssReviewSubmit from "./locales/ca/homebuyer-oss-review-submit.json";
import esHomebuyerOssReviewSubmit from "./locales/es/homebuyer-oss-review-submit.json";
import nlHomebuyerOssReviewSubmit from "./locales/nl/homebuyer-oss-review-submit.json";
// /*HOMEBUYER INVOICES*/
import enHomebuyerInvoices from "./locales/en/homebuyer-invoices.json";
import caHomebuyerInvoices from "./locales/ca/homebuyer-invoices.json";
import esHomebuyerInvoices from "./locales/es/homebuyer-invoices.json";
import nlHomebuyerInvoices from "./locales/nl/homebuyer-invoices.json";
// /*HOMEBUYER COMMUNICATION*/
import enHomebuyerCommunication from "./locales/en/homebuyer-communication.json";
import caHomebuyerCommunication from "./locales/ca/homebuyer-communication.json";
import esHomebuyerCommunication from "./locales/es/homebuyer-communication.json";
import nlHomebuyerCommunication from "./locales/nl/homebuyer-communication.json";
// /*HOMEBUYER ACCOUNT*/
import enHomebuyerAccount from "./locales/en/homebuyer-account.json";
import caHomebuyerAccount from "./locales/ca/homebuyer-account.json";
import esHomebuyerAccount from "./locales/es/homebuyer-account.json";
import nlHomebuyerAccount from "./locales/nl/homebuyer-account.json";
/* REGISTRATION */
import enLenderRegistration from "./locales/en/lender-registration.json";
import caLenderRegistration from "./locales/ca/lender-registration.json";
import esLenderRegistration from "./locales/es/lender-registration.json";
import nlLenderRegistration from "./locales/nl/lender-registration.json";
/* LENDER SIDEBAR */
import enLenderSidebar from "./locales/en/lender-sidebar.json";
import caLenderSidebar from "./locales/ca/lender-sidebar.json";
import esLenderSidebar from "./locales/es/lender-sidebar.json";
import nlLenderSidebar from "./locales/nl/lender-sidebar.json";
/*LENDER DASHBOARD*/
import enLenderDashboard from "./locales/en/lender-dashboard.json";
import caLenderDashboard from "./locales/ca/lender-dashboard.json";
import esLenderDashboard from "./locales/es/lender-dashboard.json";
import nlLenderDashboard from "./locales/nl/lender-dashboard.json";
/*LENDER APPLICATIONS PAGE*/
import enLenderLoanCases from "./locales/en/lender-loan-cases.json";
import caLenderLoanCases from "./locales/ca/lender-loan-cases.json";
import esLenderLoanCases from "./locales/es/lender-loan-cases.json";
import nlLenderLoanCases from "./locales/nl/lender-loan-cases.json";
/*LENDER APPLICATION REVIEW*/
import enLenderApplicationReview from "./locales/en/lender-application-review.json";
import caLenderApplicationReview from "./locales/ca/lender-application-review.json";
import esLenderApplicationReview from "./locales/es/lender-application-review.json";
import nlLenderApplicationReview from "./locales/nl/lender-application-review.json";
/*LENDER APPLICATION REVIEW LAYOUT*/
import enLenderManualLoanCaseLayout from "./locales/en/lender-manual-loan-case-layout.json";
import caLenderManualLoanCaseLayout from "./locales/ca/lender-manual-loan-case-layout.json";
import esLenderManualLoanCaseLayout from "./locales/es/lender-manual-loan-case-layout.json";
import nlLenderManualLoanCaseLayout from "./locales/nl/lender-manual-loan-case-layout.json";
// /*LENDER PERSONAL INFO*/
import enLenderPersonalInfo from "./locales/en/lender-personal-info.json";
import caLenderPersonalInfo from "./locales/ca/lender-personal-info.json";
import esLenderPersonalInfo from "./locales/es/lender-personal-info.json";
import nlLenderPersonalInfo from "./locales/nl/lender-personal-info.json";
// /*LENDER FINANCIAL INFO*/
import enLenderFinanciallInfo from "./locales/en/lender-financial-info.json";
import caLenderFinanciallInfo from "./locales/ca/lender-financial-info.json";
import esLenderFinanciallInfo from "./locales/es/lender-financial-info.json";
import nlLenderFinanciallInfo from "./locales/nl/lender-financial-info.json";
// /*LENDER DOCUMENTS*/
import enLenderDocuments from "./locales/en/lender-documents.json";
import caLenderDocuments from "./locales/ca/lender-documents.json";
import esLenderDocuments from "./locales/es/lender-documents.json";
import nlLenderDocuments from "./locales/nl/lender-documents.json";
/*LENDER PROPERTY INFO*/
import enLenderPropertylInfo from "./locales/en/lender-property-info.json";
import caLenderPropertylInfo from "./locales/ca/lender-property-info.json";
import esLenderPropertylInfo from "./locales/es/lender-property-info.json";
import nlLenderPropertylInfo from "./locales/nl/lender-property-info.json";
/*LENDER FINAL LOAN DETAILS*/
import enLenderFinalLoanDetails from "./locales/en/lender-final-loan-details.json";
import caLenderFinalLoanDetails from "./locales/ca/lender-final-loan-details.json";
import esLenderFinalLoanDetails from "./locales/es/lender-final-loan-details.json";
import nlLenderFinalLoanDetails from "./locales/nl/lender-final-loan-details.json";
/*LENDER DECISION SUBMISSION*/
import enLenderDecisionSubmission from "./locales/en/lender-submit-decision.json";
import caLenderDecisionSubmission from "./locales/ca/lender-submit-decision.json";
import esLenderDecisionSubmission from "./locales/es/lender-submit-decision.json";
import nlLenderDecisionSubmission from "./locales/nl/lender-submit-decision.json";
/*LENDER ADDITIONAL LOAN*/
import enLenderAdditionalLoan from "./locales/en/lender-additional-loan.json";
import caLenderAdditionalLoan from "./locales/ca/lender-additional-loan.json";
import esLenderAdditionalLoan from "./locales/es/lender-additional-loan.json";
import nlLenderAdditionalLoan from "./locales/nl/lender-additional-loan.json";
// /*LENDER INVOICES*/
import enLenderInvoices from "./locales/en/lender-invoices.json";
import caLenderInvoices from "./locales/ca/lender-invoices.json";
import esLenderInvoices from "./locales/es/lender-invoices.json";
import nlLenderInvoices from "./locales/nl/lender-invoices.json";
// /*LENDER COMMUNICATION*/
import enLenderCommunication from "./locales/en/lender-communication.json";
import caLenderCommunication from "./locales/ca/lender-communication.json";
import esLenderCommunication from "./locales/es/lender-communication.json";
import nlLenderCommunication from "./locales/nl/lender-communication.json";
// /*LENDER ACCOUNT*/
import enLenderAccount from "./locales/en/lender-account.json";
import caLenderAccount from "./locales/ca/lender-account.json";
import esLenderAccount from "./locales/es/lender-account.json";
import nlLenderAccount from "./locales/nl/lender-account.json";
// /*OSS REGISTRATION LAYOUT*//
import enOssRegistrationLayout from "./locales/en/oss-registration-layout.json";
import caOssRegistrationLayout from "./locales/ca/oss-registration-layout.json";
import esOssRegistrationLayout from "./locales/es/oss-registration-layout.json";
import nlOssRegistrationLayout from "./locales/nl/oss-registration-layout.json";
// /*OSS REGISTRATION STEP ONE*//
import enOssRegistrationStepOne from "./locales/en/oss-registration-step1.json";
import caOssRegistrationStepOne from "./locales/ca/oss-registration-step1.json";
import esOssRegistrationStepOne from "./locales/es/oss-registration-step1.json";
import nlOssRegistrationStepOne from "./locales/nl/oss-registration-step1.json";
// /*OSS REGISTRATION ACCESS CODE*//
import enOssRegistrationAccessCode from "./locales/en/oss-registration-access-code.json";
import caOssRegistrationAccessCode from "./locales/ca/oss-registration-access-code.json";
import esOssRegistrationAccessCode from "./locales/es/oss-registration-access-code.json";
import nlOssRegistrationAccessCode from "./locales/nl/oss-registration-access-code.json";
// /*OSS REGISTRATION STEP TWO*//
import enOssRegistrationStepTwo from "./locales/en/oss-registration-company-details.json";
import caOssRegistrationStepTwo from "./locales/ca/oss-registration-company-details.json";
import esOssRegistrationStepTwo from "./locales/es/oss-registration-company-details.json";
import nlOssRegistrationStepTwo from "./locales/nl/oss-registration-company-details.json";
// /*OSS REGISTRATION SERVICES*//
import enOssRegistrationServices from "./locales/en/oss-registration-services.json";
import caOssRegistrationServices from "./locales/ca/oss-registration-services.json";
import esOssRegistrationServices from "./locales/es/oss-registration-services.json";
import nlOssRegistrationServices from "./locales/nl/oss-registration-services.json";
// /*OSS REGISTRATION REVIE*//
import enOssRegistrationReview from "./locales/en/oss-registration-review.json";
import caOssRegistrationReview from "./locales/ca/oss-registration-review.json";
import esOssRegistrationReview from "./locales/es/oss-registration-review.json";
import nlOssRegistrationReview from "./locales/nl/oss-registration-review.json";
/* OSS SIDEBAR */
import enOssSidebar from "./locales/en/oss-sidebar.json";
import caOssSidebar from "./locales/ca/oss-sidebar.json";
import esOssSidebar from "./locales/es/oss-sidebar.json";
import nlOssSidebar from "./locales/nl/oss-sidebar.json";
/*OSS DASHBOARD*/
import enOssDashboard from "./locales/en/oss-dashboard.json";
import caOssDashboard from "./locales/ca/oss-dashboard.json";
import esOssDashboard from "./locales/es/oss-dashboard.json";
import nlOssDashboard from "./locales/nl/oss-dashboard.json";
/*OSS REQUESTS*/
import enOssRequests from "./locales/en/oss-requests.json";
import caOssRequests from "./locales/ca/oss-requests.json";
import esOssRequests from "./locales/es/oss-requests.json";
import nlOssRequests from "./locales/nl/oss-requests.json";
/*OSS REQUEST DETAIL 1*/
import enOssRequestDetail1 from "./locales/en/oss-request-details1.json";
import caOssRequestDetail1 from "./locales/ca/oss-request-details1.json";
import esOssRequestDetail1 from "./locales/es/oss-request-details1.json";
import nlOssRequestDetail1 from "./locales/nl/oss-request-details1.json";
// /*OSS PROJECTS*/
import enOssProjects from "./locales/en/oss-projects.json";
import caOssProjects from "./locales/ca/oss-projects.json";
import esOssProjects from "./locales/es/oss-projects.json";
import nlOssProjects from "./locales/nl/oss-projects.json";
// /*PROJECTS*/
import enOssProjectLayout from "./locales/en/oss-project-layout.json";
import caOssProjectLayout from "./locales/ca/oss-project-layout.json";
import esOssProjectLayout from "./locales/es/oss-project-layout.json";
import nlOssProjectLayout from "./locales/nl/oss-project-layout.json";
// /*PROJECTS STEP 1*/
import enOssProjectPropertyInformation from "./locales/en/oss-project-property-information.json";
import caOssProjectPropertyInformation from "./locales/ca/oss-project-property-information.json";
import esOssProjectPropertyInformation from "./locales/es/oss-project-property-information.json";
import nlOssProjectPropertyInformation from "./locales/nl/oss-project-property-information.json";
// /*PROJECT STEP 2*/
import enOssProjectPreAssessment from "./locales/en/oss-project-pre-assessment.json";
import caOssProjectPreAssessment from "./locales/ca/oss-project-pre-assessment.json";
import esOssProjectPreAssessment from "./locales/es/oss-project-pre-assessment.json";
import nlOssProjectPreAssessment from "./locales/nl/oss-project-pre-assessment.json";
// /*PROJECT STEP 3*/
import enProjectRenovationPlan from "./locales/en/renovation-project-renovation-plan.json";
import caProjectRenovationPlan from "./locales/ca/renovation-project-renovation-plan.json";
import esProjectRenovationPlan from "./locales/es/renovation-project-renovation-plan.json";
import nlProjectRenovationPlan from "./locales/nl/renovation-project-renovation-plan.json";
// /*PROJECT STEP 4*/
import enProjectEPC from "./locales/en/renovation-project-epc.json";
import caProjectEPC from "./locales/ca/renovation-project-epc.json";
import esProjectEPC from "./locales/es/renovation-project-epc.json";
import nlProjectEPC from "./locales/nl/renovation-project-epc.json";
// /*PROJECT STEP 5*/
import enProjectHomeRenovation from "./locales/en/renovation-project-works-budget.json";
import caProjectHomeRenovation from "./locales/ca/renovation-project-works-budget.json";
import esProjectHomeRenovation from "./locales/es/renovation-project-works-budget.json";
import nlProjectHomeRenovation from "./locales/nl/renovation-project-works-budget.json";
// /*PROJECT STEP 6*/
import enProjectSubsidiesGrants from "./locales/en/renovation-project-subsidies-grants.json";
import caProjectSubsidiesGrants from "./locales/ca/renovation-project-subsidies-grants.json";
import esProjectSubsidiesGrants from "./locales/es/renovation-project-subsidies-grants.json";
import nlProjectSubsidiesGrants from "./locales/nl/renovation-project-subsidies-grants.json";
// /*PROJECT STEP 7*/
import enProjectFinancing from "./locales/en/renovation-project-financing.json";
import caProjectFinancing from "./locales/ca/renovation-project-financing.json";
import esProjectFinancing from "./locales/es/renovation-project-financing.json";
import nlProjectFinancing from "./locales/nl/renovation-project-financing.json";
// /*PROJECT STEP 8*/
import enProjectMonitoring from "./locales/en/renovation-project-monitoring.json";
import caProjectMonitoring from "./locales/ca/renovation-project-monitoring.json";
import esProjectMonitoring from "./locales/es/renovation-project-monitoring.json";
import nlProjectMonitoring from "./locales/nl/renovation-project-monitoring.json";
// /*OSS INVOICES*/
import enOssInvoices from "./locales/en/oss-invoices.json";
import caOssInvoices from "./locales/ca/oss-invoices.json";
import esOssInvoices from "./locales/es/oss-invoices.json";
import nlOssInvoices from "./locales/nl/oss-invoices.json";
/*OSS COMMUNICATION*/
import enOssCommunication from "./locales/en/oss-communication.json";
import caOssCommunication from "./locales/ca/oss-communication.json";
import esOssCommunication from "./locales/es/oss-communication.json";
import nlOssCommunication from "./locales/nl/oss-communication.json";
/*OSS ACCOUNT*/
import enOssAccount from "./locales/en/oss-account.json";
import caOssAccount from "./locales/ca/oss-account.json";
import esOssAccount from "./locales/es/oss-account.json";
import nlOssAccount from "./locales/nl/oss-account.json";
/*ADMIN*/
import enAdminSidebar from "./locales/en/admin-sidebar.json";
import caAdminSidebar from "./locales/ca/admin-sidebar.json";
import esAdminSidebar from "./locales/es/admin-sidebar.json";
import nlAdminSidebar from "./locales/nl/admin-sidebar.json";
/*ADMIN DASHBOARD*/
import enAdminDashboard from "./locales/en/admin-dashboard.json";
import caAdminDashboard from "./locales/ca/admin-dashboard.json";
import esAdminDashboard from "./locales/es/admin-dashboard.json";
import nlAdminDashboard from "./locales/nl/admin-dashboard.json";
/*ADMIN RECENT ACTIVITY*/
import enAdminActivity from "./locales/en/admin-activity.json";
import caAdminActivity from "./locales/ca/admin-activity.json";
import esAdminActivity from "./locales/es/admin-activity.json";
import nlAdminActivity from "./locales/nl/admin-activity.json";
/*ADMIN REPORTING*/
import enAdminReporting from "./locales/en/admin-reporting.json";
import caAdminReporting from "./locales/ca/admin-reporting.json";
import esAdminReporting from "./locales/es/admin-reporting.json";
import nlAdminReporting from "./locales/nl/admin-reporting.json";
/*ADMIN USERS*/
import enAdminUsers from "./locales/en/admin-users.json";
import caAdminUsers from "./locales/ca/admin-users.json";
import esAdminUsers from "./locales/es/admin-users.json";
import nlAdminUsers from "./locales/nl/admin-users.json";
/*ADMIN USER*/
import enAdminUser from "./locales/en/admin-user-profile.json";
import caAdminUser from "./locales/ca/admin-user-profile.json";
import esAdminUser from "./locales/es/admin-user-profile.json";
import nlAdminUser from "./locales/nl/admin-user-profile.json";
/*ADMIN ORGANISATIONS*/
import enAdminOrganisations from "./locales/en/admin-organisations.json";
import caAdminOrganisations from "./locales/ca/admin-organisations.json";
import esAdminOrganisations from "./locales/es/admin-organisations.json";
import nlAdminOrganisations from "./locales/nl/admin-organisations.json";
/*ADMIN ORGANISATION DETAILS*/
import enAdminOrganisationDetail from "./locales/en/admin-organisation-detail.json";
import caAdminOrganisationDetail from "./locales/ca/admin-organisation-detail.json";
import esAdminOrganisationDetail from "./locales/es/admin-organisation-detail.json";
import nlAdminOrganisationDetail from "./locales/nl/admin-organisation-detail.json";
/*ADMIN REFERENCE DATA */
import enAdminReferenceData from "./locales/en/admin-reference-data.json";
import caAdminReferenceData from "./locales/ca/admin-reference-data.json";
import esAdminReferenceData from "./locales/es/admin-reference-data.json";
import nlAdminReferenceData from "./locales/nl/admin-reference-data.json";
/*ADMIN FUNDING SOURCES*/
import enAdminFundingSources from "./locales/en/admin-funding-sources.json";
import caAdminFundingSources from "./locales/ca/admin-funding-sources.json";
import esAdminFundingSources from "./locales/es/admin-funding-sources.json";
import nlAdminFundingSources from "./locales/nl/admin-funding-sources.json";
/*ADMIN MARKET REGIONS*/
import enAdminMarketRegions from "./locales/en/admin-market-regions.json";
import caAdminMarketRegions from "./locales/ca/admin-market-regions.json";
import esAdminMarketRegions from "./locales/es/admin-market-regions.json";
import nlAdminMarketRegions from "./locales/nl/admin-market-regions.json";
/*ADMIN OSS REQUESTS*/
import enAdminRequests from "./locales/en/admin-requests.json";
import caAdminRequests from "./locales/ca/admin-requests.json";
import esAdminRequests from "./locales/es/admin-requests.json";
import nlAdminRequests from "./locales/nl/admin-requests.json";
/*ADMIN ACCOUNT*/
import enAdminAccount from "./locales/en/admin-account.json";
import caAdminAccount from "./locales/ca/admin-account.json";
import esAdminAccount from "./locales/es/admin-account.json";
import nlAdminAccount from "./locales/nl/admin-account.json";
/*LENDER MANUAL REVIEW SAVE*/
import enLenderManualReviewSave from "./locales/en/lender-manual-review-save.json";
import caLenderManualReviewSave from "./locales/ca/lender-manual-review-save.json";
import esLenderManualReviewSave from "./locales/es/lender-manual-review-save.json";
import nlLenderManualReviewSave from "./locales/nl/lender-manual-review-save.json";
/*RENOVATION PROJECT LAYOUT*/
import enRenovationProjectLayout from "./locales/en/renovation-project-layout.json";
import caRenovationProjectLayout from "./locales/ca/renovation-project-layout.json";
import esRenovationProjectLayout from "./locales/es/renovation-project-layout.json";
import nlRenovationProjectLayout from "./locales/nl/renovation-project-layout.json";
/*HOMEBUYER INVITATION*/
import enHomebuyerInvitation from "./locales/en/homebuyer-invitation.json";
import caHomebuyerInvitation from "./locales/ca/homebuyer-invitation.json";
import esHomebuyerInvitation from "./locales/es/homebuyer-invitation.json";
import nlHomebuyerInvitation from "./locales/nl/homebuyer-invitation.json";
/*PLATFORM ADMIN INVITATION*/
import enPlatformAdminInvitation from "./locales/en/platform-admin-invitation.json";
import caPlatformAdminInvitation from "./locales/ca/platform-admin-invitation.json";
import esPlatformAdminInvitation from "./locales/es/platform-admin-invitation.json";
import nlPlatformAdminInvitation from "./locales/nl/platform-admin-invitation.json";
/*LOAN SIMULATOR*/
import enLoanSimulator from "./locales/en/loan-simulator.json";
import caLoanSimulator from "./locales/ca/loan-simulator.json";
import esLoanSimulator from "./locales/es/loan-simulator.json";
import nlLoanSimulator from "./locales/nl/loan-simulator.json";
/*LOAN SIMULATOR BELGIUM*/
import enLoanSimulatorBelgium from "./locales/en/loan-simulator-belgium.json";
import caLoanSimulatorBelgium from "./locales/ca/loan-simulator-belgium.json";
import esLoanSimulatorBelgium from "./locales/es/loan-simulator-belgium.json";
import nlLoanSimulatorBelgium from "./locales/nl/loan-simulator-belgium.json";
/*LOAN SIMULATOR GIRONA*/
import enLoanSimulatorGirona from "./locales/en/loan-simulator-girona.json";
import caLoanSimulatorGirona from "./locales/ca/loan-simulator-girona.json";
import esLoanSimulatorGirona from "./locales/es/loan-simulator-girona.json";
import nlLoanSimulatorGirona from "./locales/nl/loan-simulator-girona.json";
/*INSTALLMENTS CALCULATOR*/
import enInstallmentsCalculator from "./locales/en/installments-calculator.json";
import caInstallmentsCalculator from "./locales/ca/installments-calculator.json";
import esInstallmentsCalculator from "./locales/es/installments-calculator.json";
import nlInstallmentsCalculator from "./locales/nl/installments-calculator.json";
/*INSTALLMENTS CALCULATOR GIRONA*/
import enInstallmentsCalculatorGirona from "./locales/en/installments-calculator-girona.json";
import caInstallmentsCalculatorGirona from "./locales/ca/installments-calculator-girona.json";
import esInstallmentsCalculatorGirona from "./locales/es/installments-calculator-girona.json";
import nlInstallmentsCalculatorGirona from "./locales/nl/installments-calculator-girona.json";
/*RENOVATION COST ESTIMATOR*/
import enRenovationCostEstimator from "./locales/en/renovation-cost-estimator.json";
import caRenovationCostEstimator from "./locales/ca/renovation-cost-estimator.json";
import esRenovationCostEstimator from "./locales/es/renovation-cost-estimator.json";
import nlRenovationCostEstimator from "./locales/nl/renovation-cost-estimator.json";
/*RENOVATION COST ESTIMATOR GIRONA*/
import enRenovationCostEstimatorGirona from "./locales/en/renovation-cost-estimator-girona.json";
import caRenovationCostEstimatorGirona from "./locales/ca/renovation-cost-estimator-girona.json";
import esRenovationCostEstimatorGirona from "./locales/es/renovation-cost-estimator-girona.json";
import nlRenovationCostEstimatorGirona from "./locales/nl/renovation-cost-estimator-girona.json";

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  supportedLngs: ["en", "es", "ca", "nl"],

  fallbackLng: "en",

  load: "languageOnly",

  interpolation: {
    escapeValue: false,
  },

  /* namespaces */
  ns: [
    "common",
    "notifications",
    "home",
    "guard",
    "homebuyer-registration",
    "homebuyer-sidebar",
    "homebuyer-dashboard",
    "dossierIntro",
    "select-service",
    "homebuyer-first-login",
    "homebuyer-personal-info",
    "homebuyer-dossier-layout",
    "homebuyer-financial-info",
    "homebuyer-documents",
    "homebuyer-extracted-data",
    "homebuyer-property-info",
    "homebuyer-review-submit",
    "homebuyer-dashboard-draft",
    "homebuyer-oss-modal",
    "external-renovation",
    "homebuyer-oss-property-details",
    "homebuyer-oss-partners",
    "homebuyer-oss-review-submit",
    "homebuyer-invoices",
    "homebuyer-communication",
    "homebuyer-account",
    "lender-registration",
    "lender-sidebar",
    "lender-dashboard",
    "lender-loan-cases",
    "lender-application-review",
    "lender-manual-loan-case-layout",
    "lender-personal-info",
    "lender-financial-info",
    "lender-documents",
    "lender-property-info",
    "lender-final-loan-details",
    "lender-submit-decision",
    "lender-additional-loan",
    "lender-invoices",
    "lender-communication",
    "lender-account",
    "oss-registration-layout",
    "oss-registration-step1",
    "oss-registration-access-code",
    "oss-registration-company-details",
    "oss-registration-services",
    "oss-registration-review",
    "oss-sidebar",
    "oss-dashboard",
    "oss-requests",
    "oss-request-details1",
    "oss-projects",
    "oss-project-layout",
    "oss-project-property-information",
    "oss-project-pre-assessment",
    "renovation-project-renovation-plan",
    "renovation-project-epc",
    "renovation-project-works-budget",
    "renovation-project-subsidies-grants",
    "renovation-project-financing",
    "renovation-project-monitoring",
    "oss-invoices",
    "oss-communication",
    "oss-account",
    "admin-sidebar",
    "admin-dashboard",
    "admin-reporting",
    "admin-users",
    "admin-user-profile",
    "admin-organisations",
    "admin-organisation-detail",
    "admin-reference-data",
    "admin-funding-sources",
    "admin-market-regions",
    "admin-requests",
    "admin-account",
    "admin-activity",
    "lender-manual-review-save",
    "renovation-project-layout",
    "homebuyer-invitation",
    "platform-admin-invitation",
    "loan-simulator",
    "loan-simulator-belgium",
    "loan-simulator-girona",
    "installments-calculator",
    "installments-calculator-girona",
    "renovation-cost-estimator",
    "renovation-cost-estimator-girona",
  ],

  defaultNS: "common",

  react: {
    useSuspense: false,
  },

  resources: {
    en: {
      common: enCommon,
      notifications: enNotifications,
      guard: enRouteGuard,
      home: enHomePage,
      "homebuyer-registration": enRegistration,
      "homebuyer-sidebar": enHomebuyerSidebar,
      "homebuyer-dashboard": enHomebuyerDashboard,
      dossierIntro: enDossierIntro,
      "select-service": enSelectService,
      "homebuyer-first-login": enHomebuyerFirstLogin,
      "homebuyer-personal-info": enHomebuyerPersonalInfo,
      "homebuyer-dossier-layout": enDossierLayout,
      "homebuyer-financial-info": enHomebuyerFinancialInfo,
      "homebuyer-documents": enHomebuyerDocuments,
      "homebuyer-extracted-data": enHomebuyerExtractedData,
      "homebuyer-property-info": enHomebuyerPropertylInfo,
      "homebuyer-review-submit": enHomebuyerReviewSubmit,
      "homebuyer-dashboard-draft": enHomebuyerDashboardDraft,
      "external-renovation": enHomebuyerExternalOss,
      "homebuyer-oss-modal": enHomebuyerOssModal,
      "homebuyer-oss-property-details": enHomebuyerOssPropertyDetails,
      "homebuyer-oss-partners": enHomebuyerOssPartners,
      "homebuyer-oss-review-submit": enHomebuyerOssReviewSubmit,
      "homebuyer-invoices": enHomebuyerInvoices,
      "homebuyer-communication": enHomebuyerCommunication,
      "homebuyer-account": enHomebuyerAccount,
      "lender-registration": enLenderRegistration,
      "lender-sidebar": enLenderSidebar,
      "lender-dashboard": enLenderDashboard,
      "lender-loan-cases": enLenderLoanCases,
      "lender-application-review": enLenderApplicationReview,
      "lender-manual-loan-case-layout": enLenderManualLoanCaseLayout,
      "lender-personal-info": enLenderPersonalInfo,
      "lender-financial-info": enLenderFinanciallInfo,
      "lender-documents": enLenderDocuments,
      "lender-final-loan-details": enLenderFinalLoanDetails,
      "lender-property-info": enLenderPropertylInfo,
      "lender-submit-decision": enLenderDecisionSubmission,
      "lender-additional-loan": enLenderAdditionalLoan,
      "lender-invoices": enLenderInvoices,
      "lender-communication": enLenderCommunication,
      "lender-account": enLenderAccount,
      "oss-registration-layout": enOssRegistrationLayout,
      "oss-registration-step1": enOssRegistrationStepOne,
      "oss-registration-access-code": enOssRegistrationAccessCode,
      "oss-registration-company-details": enOssRegistrationStepTwo,
      "oss-registration-services": enOssRegistrationServices,
      "oss-registration-review": enOssRegistrationReview,
      "oss-sidebar": enOssSidebar,
      "oss-dashboard": enOssDashboard,
      "oss-requests": enOssRequests,
      "oss-request-details1": enOssRequestDetail1,
      "oss-projects": enOssProjects,
      "oss-project-layout": enOssProjectLayout,
      "oss-project-property-information": enOssProjectPropertyInformation,
      "oss-project-pre-assessment": enOssProjectPreAssessment,
      "renovation-project-renovation-plan": enProjectRenovationPlan,
      "renovation-project-epc": enProjectEPC,
      "renovation-project-works-budget": enProjectHomeRenovation,
      "renovation-project-subsidies-grants": enProjectSubsidiesGrants,
      "renovation-project-financing": enProjectFinancing,
      "renovation-project-monitoring": enProjectMonitoring,
      "oss-invoices": enOssInvoices,
      "oss-communication": enOssCommunication,
      "oss-account": enOssAccount,
      "admin-sidebar": enAdminSidebar,
      "admin-dashboard": enAdminDashboard,
      "admin-reporting": enAdminReporting,
      "admin-users": enAdminUsers,
      "admin-user-profile": enAdminUser,
      "admin-organisations": enAdminOrganisations,
      "admin-organisation-detail": enAdminOrganisationDetail,
      "admin-reference-data": enAdminReferenceData,
      "admin-funding-sources": enAdminFundingSources,
      "admin-market-regions": enAdminMarketRegions,
      "admin-requests": enAdminRequests,
      "admin-account": enAdminAccount,
      "admin-activity": enAdminActivity,
      "lender-manual-review-save": enLenderManualReviewSave,
      "renovation-project-layout": enRenovationProjectLayout,
      "homebuyer-invitation": enHomebuyerInvitation,
      "platform-admin-invitation": enPlatformAdminInvitation,
      "loan-simulator": enLoanSimulator,
      "loan-simulator-belgium": enLoanSimulatorBelgium,
      "loan-simulator-girona": enLoanSimulatorGirona,
      "installments-calculator": enInstallmentsCalculator,
      "installments-calculator-girona": enInstallmentsCalculatorGirona,
      "renovation-cost-estimator": enRenovationCostEstimator,
      "renovation-cost-estimator-girona": enRenovationCostEstimatorGirona,
    },
    es: {
      common: esCommon,
      notifications: esNotifications,
      guard: esRouteGuard,
      home: esHomePage,
      "homebuyer-registration": esRegistration,
      "homebuyer-sidebar": esHomebuyerSidebar,
      "homebuyer-dashboard": esHomebuyerDashboard,
      dossierIntro: esDossierIntro,
      "select-service": esSelectService,
      "homebuyer-first-login": esHomebuyerFirstLogin,
      "homebuyer-personal-info": esHomebuyerPersonalInfo,
      "homebuyer-dossier-layout": esDossierLayout,
      "homebuyer-financial-info": esHomebuyerFinancialInfo,
      "homebuyer-documents": esHomebuyerDocuments,
      "homebuyer-extracted-data": esHomebuyerExtractedData,
      "homebuyer-property-info": esHomebuyerPropertylInfo,
      "homebuyer-review-submit": esHomebuyerReviewSubmit,
      "homebuyer-dashboard-draft": esHomebuyerDashboardDraft,
      "external-renovation": esHomebuyerExternalOss,
      "homebuyer-oss-modal": esHomebuyerOssModal,
      "homebuyer-oss-property-details": esHomebuyerOssPropertyDetails,
      "homebuyer-oss-partners": esHomebuyerOssPartners,
      "homebuyer-oss-review-submit": esHomebuyerOssReviewSubmit,
      "homebuyer-invoices": esHomebuyerInvoices,
      "homebuyer-communication": esHomebuyerCommunication,
      "homebuyer-account": esHomebuyerAccount,
      "lender-registration": esLenderRegistration,
      "lender-sidebar": esLenderSidebar,
      "lender-dashboard": esLenderDashboard,
      "lender-loan-cases": esLenderLoanCases,
      "lender-application-review": esLenderApplicationReview,
      "lender-manual-loan-case-layout": esLenderManualLoanCaseLayout,
      "lender-personal-info": esLenderPersonalInfo,
      "lender-financial-info": esLenderFinanciallInfo,
      "lender-documents": esLenderDocuments,
      "lender-final-loan-details": esLenderFinalLoanDetails,
      "lender-property-info": esLenderPropertylInfo,
      "lender-submit-decision": esLenderDecisionSubmission,
      "lender-additional-loan": esLenderAdditionalLoan,
      "lender-invoices": esLenderInvoices,
      "lender-communication": esLenderCommunication,
      "lender-account": esLenderAccount,
      "oss-registration-layout": esOssRegistrationLayout,
      "oss-registration-step1": esOssRegistrationStepOne,
      "oss-registration-access-code": esOssRegistrationAccessCode,
      "oss-registration-company-details": esOssRegistrationStepTwo,
      "oss-registration-services": esOssRegistrationServices,
      "oss-registration-review": esOssRegistrationReview,
      "oss-sidebar": esOssSidebar,
      "oss-dashboard": esOssDashboard,
      "oss-requests": esOssRequests,
      "oss-request-details1": esOssRequestDetail1,
      "oss-projects": esOssProjects,
      "oss-project-layout": esOssProjectLayout,
      "oss-project-property-information": esOssProjectPropertyInformation,
      "oss-project-pre-assessment": esOssProjectPreAssessment,
      "renovation-project-renovation-plan": esProjectRenovationPlan,
      "renovation-project-epc": esProjectEPC,
      "renovation-project-works-budget": esProjectHomeRenovation,
      "renovation-project-subsidies-grants": esProjectSubsidiesGrants,
      "renovation-project-financing": esProjectFinancing,
      "renovation-project-monitoring": esProjectMonitoring,
      "oss-invoices": esOssInvoices,
      "oss-communication": esOssCommunication,
      "oss-account": esOssAccount,
      "admin-sidebar": esAdminSidebar,
      "admin-dashboard": esAdminDashboard,
      "admin-reporting": esAdminReporting,
      "admin-users": esAdminUsers,
      "admin-user-profile": esAdminUser,
      "admin-organisations": esAdminOrganisations,
      "admin-organisation-detail": esAdminOrganisationDetail,
      "admin-reference-data": esAdminReferenceData,
      "admin-funding-sources": esAdminFundingSources,
      "admin-market-regions": esAdminMarketRegions,
      "admin-requests": esAdminRequests,
      "admin-account": esAdminAccount,
      "admin-activity": esAdminActivity,
      "lender-manual-review-save": esLenderManualReviewSave,
      "renovation-project-layout": esRenovationProjectLayout,
      "homebuyer-invitation": esHomebuyerInvitation,
      "platform-admin-invitation": esPlatformAdminInvitation,
      "loan-simulator": esLoanSimulator,
      "loan-simulator-belgium": esLoanSimulatorBelgium,
      "loan-simulator-girona": esLoanSimulatorGirona,
      "installments-calculator": esInstallmentsCalculator,
      "installments-calculator-girona": esInstallmentsCalculatorGirona,
      "renovation-cost-estimator": esRenovationCostEstimator,
      "renovation-cost-estimator-girona": esRenovationCostEstimatorGirona,
    },
    ca: {
      common: caCommon,
      notifications: caNotifications,
      guard: caRouteGuard,
      home: caHomePage,
      "homebuyer-registration": caRegistration,
      "homebuyer-sidebar": caHomebuyerSidebar,
      "homebuyer-dashboard": caHomebuyerDashboard,
      dossierIntro: caDossierIntro,
      "select-service": caSelectService,
      "homebuyer-first-login": caHomebuyerFirstLogin,
      "homebuyer-personal-info": caHomebuyerPersonalInfo,
      "homebuyer-dossier-layout": caDossierLayout,
      "homebuyer-financial-info": caHomebuyerFinancialInfo,
      "homebuyer-documents": caHomebuyerDocuments,
      "homebuyer-extracted-data": caHomebuyerExtractedData,
      "homebuyer-property-info": caHomebuyerPropertylInfo,
      "homebuyer-review-submit": caHomebuyerReviewSubmit,
      "homebuyer-dashboard-draft": caHomebuyerDashboardDraft,
      "external-renovation": caHomebuyerExternalOss,
      "homebuyer-oss-modal": caHomebuyerOssModal,
      "homebuyer-oss-property-details": caHomebuyerOssPropertyDetails,
      "homebuyer-oss-partners": caHomebuyerOssPartners,
      "homebuyer-oss-review-submit": caHomebuyerOssReviewSubmit,
      "homebuyer-invoices": caHomebuyerInvoices,
      "homebuyer-communication": caHomebuyerCommunication,
      "homebuyer-account": caHomebuyerAccount,
      "lender-registration": caLenderRegistration,
      "lender-sidebar": caLenderSidebar,
      "lender-dashboard": caLenderDashboard,
      "lender-loan-cases": caLenderLoanCases,
      "lender-application-review": caLenderApplicationReview,
      "lender-manual-loan-case-layout": caLenderManualLoanCaseLayout,
      "lender-personal-info": caLenderPersonalInfo,
      "lender-financial-info": caLenderFinanciallInfo,
      "lender-documents": caLenderDocuments,
      "lender-final-loan-details": caLenderFinalLoanDetails,
      "lender-property-info": caLenderPropertylInfo,
      "lender-submit-decision": caLenderDecisionSubmission,
      "lender-additional-loan": caLenderAdditionalLoan,
      "lender-invoices": caLenderInvoices,
      "lender-communication": caLenderCommunication,
      "lender-account": caLenderAccount,
      "oss-registration-layout": caOssRegistrationLayout,
      "oss-registration-step1": caOssRegistrationStepOne,
      "oss-registration-access-code": caOssRegistrationAccessCode,
      "oss-registration-company-details": caOssRegistrationStepTwo,
      "oss-registration-services": caOssRegistrationServices,
      "oss-registration-review": caOssRegistrationReview,
      "oss-sidebar": caOssSidebar,
      "oss-dashboard": caOssDashboard,
      "oss-requests": caOssRequests,
      "oss-request-details1": caOssRequestDetail1,
      "oss-projects": caOssProjects,
      "oss-project-layout": caOssProjectLayout,
      "oss-project-property-information": caOssProjectPropertyInformation,
      "oss-project-pre-assessment": caOssProjectPreAssessment,
      "renovation-project-renovation-plan": caProjectRenovationPlan,
      "renovation-project-epc": caProjectEPC,
      "renovation-project-works-budget": caProjectHomeRenovation,
      "renovation-project-subsidies-grants": caProjectSubsidiesGrants,
      "renovation-project-financing": caProjectFinancing,
      "renovation-project-monitoring": caProjectMonitoring,
      "oss-invoices": caOssInvoices,
      "oss-communication": caOssCommunication,
      "oss-account": caOssAccount,
      "admin-sidebar": caAdminSidebar,
      "admin-dashboard": caAdminDashboard,
      "admin-reporting": caAdminReporting,
      "admin-users": caAdminUsers,
      "admin-user-profile": caAdminUser,
      "admin-organisations": caAdminOrganisations,
      "admin-organisation-detail": caAdminOrganisationDetail,
      "admin-reference-data": caAdminReferenceData,
      "admin-funding-sources": caAdminFundingSources,
      "admin-market-regions": caAdminMarketRegions,
      "admin-requests": caAdminRequests,
      "admin-account": caAdminAccount,
      "admin-activity": caAdminActivity,
      "lender-manual-review-save": caLenderManualReviewSave,
      "renovation-project-layout": caRenovationProjectLayout,
      "homebuyer-invitation": caHomebuyerInvitation,
      "platform-admin-invitation": caPlatformAdminInvitation,
      "loan-simulator": caLoanSimulator,
      "loan-simulator-belgium": caLoanSimulatorBelgium,
      "loan-simulator-girona": caLoanSimulatorGirona,
      "installments-calculator": caInstallmentsCalculator,
      "installments-calculator-girona": caInstallmentsCalculatorGirona,
      "renovation-cost-estimator": caRenovationCostEstimator,
      "renovation-cost-estimator-girona": caRenovationCostEstimatorGirona,
    },
    nl: {
      common: nlCommon,
      notifications: nlNotifications,
      guard: nlRouteGuard,
      home: nlHomePage,
      "homebuyer-registration": nlRegistration,
      "homebuyer-sidebar": nlHomebuyerSidebar,
      "homebuyer-dashboard": nlHomebuyerDashboard,
      dossierIntro: nlDossierIntro,
      "select-service": nlSelectService,
      "homebuyer-first-login": nlHomebuyerFirstLogin,
      "homebuyer-personal-info": nlHomebuyerPersonalInfo,
      "homebuyer-dossier-layout": nlDossierLayout,
      "homebuyer-financial-info": nlHomebuyerFinancialInfo,
      "homebuyer-documents": nlHomebuyerDocuments,
      "homebuyer-extracted-data": nlHomebuyerExtractedData,
      "homebuyer-property-info": nlHomebuyerPropertylInfo,
      "homebuyer-review-submit": nlHomebuyerReviewSubmit,
      "homebuyer-dashboard-draft": nlHomebuyerDashboardDraft,
      "external-renovation": nlHomebuyerExternalOss,
      "homebuyer-oss-modal": nlHomebuyerOssModal,
      "homebuyer-oss-property-details": nlHomebuyerOssPropertyDetails,
      "homebuyer-oss-partners": nlHomebuyerOssPartners,
      "homebuyer-oss-review-submit": nlHomebuyerOssReviewSubmit,
      "homebuyer-invoices": nlHomebuyerInvoices,
      "homebuyer-communication": nlHomebuyerCommunication,
      "homebuyer-account": nlHomebuyerAccount,
      "lender-registration": nlLenderRegistration,
      "lender-sidebar": nlLenderSidebar,
      "lender-dashboard": nlLenderDashboard,
      "lender-loan-cases": nlLenderLoanCases,
      "lender-application-review": nlLenderApplicationReview,
      "lender-manual-loan-case-layout": nlLenderManualLoanCaseLayout,
      "lender-personal-info": nlLenderPersonalInfo,
      "lender-financial-info": nlLenderFinanciallInfo,
      "lender-documents": nlLenderDocuments,
      "lender-final-loan-details": nlLenderFinalLoanDetails,
      "lender-property-info": nlLenderPropertylInfo,
      "lender-submit-decision": nlLenderDecisionSubmission,
      "lender-additional-loan": nlLenderAdditionalLoan,
      "lender-invoices": nlLenderInvoices,
      "lender-communication": nlLenderCommunication,
      "lender-account": nlLenderAccount,
      "oss-registration-layout": nlOssRegistrationLayout,
      "oss-registration-step1": nlOssRegistrationStepOne,
      "oss-registration-access-code": nlOssRegistrationAccessCode,
      "oss-registration-company-details": nlOssRegistrationStepTwo,
      "oss-registration-services": nlOssRegistrationServices,
      "oss-registration-review": nlOssRegistrationReview,
      "oss-sidebar": nlOssSidebar,
      "oss-dashboard": nlOssDashboard,
      "oss-requests": nlOssRequests,
      "oss-request-details1": nlOssRequestDetail1,
      "oss-projects": nlOssProjects,
      "oss-project-layout": nlOssProjectLayout,
      "oss-project-property-information": nlOssProjectPropertyInformation,
      "oss-project-pre-assessment": nlOssProjectPreAssessment,
      "renovation-project-renovation-plan": nlProjectRenovationPlan,
      "renovation-project-epc": nlProjectEPC,
      "renovation-project-works-budget": nlProjectHomeRenovation,
      "renovation-project-subsidies-grants": nlProjectSubsidiesGrants,
      "renovation-project-financing": nlProjectFinancing,
      "renovation-project-monitoring": nlProjectMonitoring,
      "oss-invoices": nlOssInvoices,
      "oss-communication": nlOssCommunication,
      "oss-account": nlOssAccount,
      "admin-sidebar": nlAdminSidebar,
      "admin-dashboard": nlAdminDashboard,
      "admin-reporting": nlAdminReporting,
      "admin-users": nlAdminUsers,
      "admin-user-profile": nlAdminUser,
      "admin-organisations": nlAdminOrganisations,
      "admin-organisation-detail": nlAdminOrganisationDetail,
      "admin-reference-data": nlAdminReferenceData,
      "admin-funding-sources": nlAdminFundingSources,
      "admin-market-regions": nlAdminMarketRegions,
      "admin-requests": nlAdminRequests,
      "admin-account": nlAdminAccount,
      "admin-activity": nlAdminActivity,
      "lender-manual-review-save": nlLenderManualReviewSave,
      "renovation-project-layout": nlRenovationProjectLayout,
      "homebuyer-invitation": nlHomebuyerInvitation,
      "platform-admin-invitation": nlPlatformAdminInvitation,
      "loan-simulator": nlLoanSimulator,
      "loan-simulator-belgium": nlLoanSimulatorBelgium,
      "loan-simulator-girona": nlLoanSimulatorGirona,
      "installments-calculator": nlInstallmentsCalculator,
      "installments-calculator-girona": nlInstallmentsCalculatorGirona,
      "renovation-cost-estimator": nlRenovationCostEstimator,
      "renovation-cost-estimator-girona": nlRenovationCostEstimatorGirona,
    },
  },
});

export default i18n;
